import React from 'react';
import { TabbedOverviewPage, SectionHeader } from '../components/OverviewSections.comp';
import { LearningImpactMethodologySection } from '../../DashboardCommon/LearningImpactMethodology.comp';

const MethodologyLearningImpactPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'How Learning Impact Is Measured',
                content: <LearningImpactMethodologySection SectionHeader={SectionHeader}/>,
            },
        ]}
    />
);

export default MethodologyLearningImpactPage;
